<template>
    <div>
        <b-button-group>
            <b-dropdown variant="default" split @click="setShowModal()" title="Save Filter Configuration Or Click the Dropdown Arrow to View all Saved Filter Configurations">
                <template #button-content>
                    <i class="fa fa-save"></i>
                    <span class="badge badge-warning" :title="`${savedFilters.length} total ${assetType} filters saved`" v-if="savedFilters.length > 0">{{ savedFilters.length }}</span>
                </template>
                <template v-if="savedFilters.length > 0">
                    <b-dropdown-item v-for="filter in savedFilters" :key="filter.id" @click="setSavedFilter(filter.id)" :title="`Apply Filter: ${filter.filter_name}`">
                        <span class="badge badge-warning" v-if="filter.is_global" title="This is a Globally Shared Filter"><i class="fa fa-globe"></i></span> {{ filter.filter_name }}
                    </b-dropdown-item>
                </template>
                <b-dropdown-item v-else disabled>-- No Saved Filters --</b-dropdown-item>
            </b-dropdown>
        </b-button-group>

        <div class="form-horizontal">
            <b-modal ref="saveFilterModal" :title="(filter.id ? 'Update' : 'Create') + ' '+assetType+' Saved Filter'" size="lg" no-fade :no-close-on-backdrop="true" ok-variant="success" :ok-title="(filter.id ? 'Update' : 'Create') + ' Saved Filter'"
                @ok="saveFilter" @show="emitShow" @hidden="emitHidden">
                <div class="row mb-4">
                    <label class="col-md-4 text-md-right col-form-label" :class="{'text-danger': errors.filter_name}">
                        Filter Name: <i class="fa fa-asterisk text-danger"></i>
                    </label>
                    <div class="col-md-6">
                        <b-form-input v-model="filter.filter_name" placeholder="Enter Filter Name" :class="{'is-invalid': errors.filter_name, 'form-inline-fix': true}" />

                        <div v-if="errors.filter_name" class="text-danger mb-1">
                            <div v-for="error in errors.filter_name">{{ error }}</div>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-md-4 text-md-right col-form-label">
                        Order By:
                    </label>
                    <div class="col-md-6">
                        <strong>{{ filter.table_config.orderBy }}</strong> <template v-if="filter.table_config.ascending == 1">Ascending</template><template v-else>Descending</template>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-md-4 text-md-right col-form-label">
                        Search Term:
                    </label>
                    <div class="col-md-6">
                        {{ filter.table_config.query }}
                    </div>
                </div>
                <div class="row mb-2" v-if="$store.state.user.is_admin">
                    <label class="col-md-4 text-md-right col-form-label">
                        Global Filter <i class="fa fa-question-circle" title="If checked, this filter will be available for all users and for use on Custom Dashboards"></i>:
                    </label>
                    <div class="col-md-6">
                        <b-form-checkbox v-model="filter.is_global" :value="1" :unchecked-value="0" plain></b-form-checkbox>
                    </div>
                </div>
                <div class="row mb-2" v-if="assetType === 'Inspection'">
                    <label class="col-md-4 text-md-right col-form-label">
                        Pin To Sidebar <i class="fa fa-question-circle"></i>:
                    </label>
                    <div class="col-md-6">
                        <b-form-checkbox v-model="filter.pin_to_sidebar" :value="1" :unchecked-value="0" plain></b-form-checkbox>
                    </div>
                </div>
            </b-modal>


            <b-modal v-if="appliedFilter" ref="deleteFilterModal" :title="'Delete Filter: ' + appliedFilter.filter_name" size="md" no-fade :no-close-on-backdrop="true" ok-variant="danger" :ok-title="'Delete Filter'"
                @ok="deleteFilter"
                @hide="resetDeleteFilter">
                <div class="alert alert-danger">
                    <p>Confirm: You are about to delete this filter. This cannot be undone.</p>
                </div>
                <div class="row mb-4">
                    <label class="col-md-4 text-md-right col-form-label" :class="{'text-danger': errors.filter_name}">Filter Name:</label>
                    <div class="col-md-6">
                        {{ appliedFilter.filter_name }}
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            assetType: {
                type: String,
                required: true,
            },

            filterKey: {
                type: String,
                required: true,
            }
        },

        data() {
            return {
                filters: [],
                filter: {
                    filter_name: null,
                    table_config: {},
                    table_filters: {},
                },
                errors: [],
            }
        },

        watch: {
            showSaveModal(newValue, oldValue){
                //Check if
                if(newValue == true)
                {
                    //Check for an applied filter
                    if(this.appliedFilter)
                    {
                        this.filter = this.appliedFilter;
                    }

                    //Show the model
                    this.$refs.saveFilterModal.show();
                }
                else
                {
                    //Hide the model
                    //this.$refs.saveFilterModal.hide();
                }
            },

            showDeleteModal(newValue, oldValue){
                //Check if
                if(newValue == true)
                {
                    //Show the model
                    this.$refs.deleteFilterModal.show();
                }
                else
                {
                    //Hide the model
                    this.$refs.deleteFilterModal.hide();
                }
            }
        },

        computed: {
            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },

            showSaveModal(){
                return this.$store.state.updateFilter;
            },

            showDeleteModal(){
                return this.$store.state.deleteFilter;
            },

            setDeleteFilter(){
                //Set it
                this.$store.commit('setDeleteFilter', true);
            },

            savedFilters(){
                //Setup
                var filters = [];

                //Loop and build
                for (var i = this.filters.length - 1; i >= 0; i--)
                {
                    //Only add the incidents
                    if(this.filters[i].asset_type == this.assetType)
                    {
                        filters.push(this.filters[i]);
                    }
                }

                //Sort it
                filters.sort(function (a, b) {
                    //Check Name
                    if (a.filter_name < b.filter_name) {
                        return -1;
                    }

                    //Check Name
                    if (a.filter_name > b.filter_name) {
                        return 1;
                    }

                    //Default
                    return 0;
                });

                //Send it
                return filters;
            },
        },

        methods: {
            setTableConfig(tableConfig){
                this.filter.table_config = tableConfig;
            },

            setTableFilters(tableFilters){
                this.filter.table_filters = tableFilters;
            },

            getFilters(){
                //Fetch it
                //Get the data
                this.$http
                    .get('filters/' + this.assetType)
                    .then(response => {
                        //Set all the data
                        this.filters = response.data;
                    })
                    .catch(response => {

                    });
            },

            setSavedFilter(id){
                //Get the filter
                var filter = null;

                //Loop and locate
                for (var i = this.filters.length - 1; i >= 0; i--)
                {
                    //Check the ID
                    if(parseInt(this.filters[i].id) == parseInt(id))
                    {
                        filter = this.filters[i];
                    }
                }

                //Set all the value - this will also set it to NULL
                this.$store.commit('setAppliedFilter', {key: this.filterKey, filter: filter});

                //Emit??
                //this.$emit('savedFilterApplied');
            },

            emitShow(bvModalEvt){
                //Send it
                this.$emit('show');
            },

            emitHidden(bvModalEvt){
                //Reset Everything too
                this.filter = {
                    filter_name: null,
                    table_config: {},
                    table_filters: {},
                };

                //Reset the errorts
                this.errors = [];

                //Emit to parent
                this.$emit('hide');

                //Commit
                this.$store.commit('setUpdateFilter', false);
            },

            setFilterParams(tableComp, extraFilters = null){
                //Setup
                var tableFilters = this.$store.state.tableFilters.filters[this.filterKey];

                //Pull the State of of the Local Storage
                //This is such a hacky way to do it, but vue-tables-2 doesn't give a way to just getVisibleCols()
                var state = localStorage.getItem(('vuetables_' + tableComp.name), null);

                //Check for NULL
                if(state)
                {
                    //Decode it
                    state = JSON.parse(state);
                }

                //Get the erequest params
                var params = tableComp.getRequestParams();

                //Build the Table Config
                var tableConfig = {
                    query: params.query,
                    orderBy: state && state.orderBy ? state.orderBy.column : tableComp.options.orderBy.column,
                    ascending: state && state.orderBy ? state.orderBy.ascending : tableComp.options.orderBy.ascending,
                    columns: tableComp.columns,
                    visible_cols: state && state.userColumnsDisplay ? state.userColumnsDisplay : null,
                    limit: tableComp.limit,
                    extraFilters: extraFilters
                };

                //Set ALL
                this.setTableConfig(tableConfig);
                this.setTableFilters(tableFilters);
            },

            //Save the filter
            saveFilter(bvModalEvt){
                //Stop the modal close
                bvModalEvt.preventDefault();

                //Lodaing
                this.saving = true;

                //Do some magic
                this.$emit('saving');

                //Set the asset
                this.filter.asset_type = this.assetType;

                //Send it
                this.$http
                .post('users/filters' + (this.filter.id ? '/' + this.filter.id : ''), this.filter)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Filter Saved');

                    //Commit to the Vuex Store
                    //this.$store.commit('upsertFilter', {filter: response.data});

                    //Apply it
                    //this.$store.commit('setAppliedFilter', response.data);
                    //this.$router.push(response.data.url + '?filter_id=' + response.data.id);
                    //Set all the value - this will also set it to NULL
                    this.$store.commit('setAppliedFilter', {key: this.filterKey, filter: response.data});

                    //Emit??
                    this.$emit('savedFilterApplied');

                    //Hide it
                    this.$refs.saveFilterModal.hide();
                })
                .catch(error => {
                    //Check for error
                    if(error.response && error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                    else
                    {
                        //Log it?
                        console.log(error);

                        //Alert the user
                        this.$toastr.error(error, 'Failed to Save Filters');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            //Delete the filter
            deleteFilter(bvModalEvt){
                //Stop the modal close
                bvModalEvt.preventDefault();

                //Lodaing
                this.saving = true;

                //Copy it to know where to go afterwards
                var deletedFilter = this.appliedFilter;

                //Send it
                this.$http
                .delete('users/filters/' + this.appliedFilter.id)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Filter Deleted');

                    //Commit to the Vuex Store
                    this.$store.commit('upsertFilter', {filter: deletedFilter, deleteMode: true});

                    //Update the Store
                    this.$refs.deleteFilterModal.hide();

                    //Clear the Applied Filter
                    this.$store.commit('setAppliedFilter', {key: this.filterKey, filter: null});
                })
                .catch(error => {
                    //Check for error
                    if(error.response && error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                    else
                    {
                        //Log it?
                        console.log(error);

                        //Alert the user
                        this.$toastr.error(error, 'Failed to Save Filters');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            setShowModal(){
                //Set it
                this.$refs.saveFilterModal.show();
            },

            resetDeleteFilter(bvModalEvt){
                //Stop
                //bvModalEvt.preventDefault();

                //Commit
                this.$store.commit('setDeleteFilter', false);
            },
        },

        mounted() {
            //Fetch the filters
            this.getFilters();
        }
    }
</script>

<style type="text/css" scoped>
    .form-inline-fix {
        width: 100%;
    }
</style>